export default __webpack_public_path__ + "static/media/activity-unloading.87d1e67b.svg";